// Dashboard.tsx
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import PedidosPorClienteChart from "../Charts/ClientesCharts/PedidosPorClienteChart";
import DistribuicaoPedidosChart from "../Charts/ClientesCharts/DistribuicaoPedidosChart";
import ValorPedidosPorClienteChart from "../Charts/ClientesCharts/ValorPedidosPorClienteChart";
import useDashboardData from "./useDashboardData ";
import StatusGaugeChart from "../Charts/ClientesCharts/StatusGaugeChart";
import ClientesGaugeChart from "../Charts/ClientesCharts/ClientesGaugeChart";
import MapaLocalizacaoClientes from "../Charts/ClientesCharts/MapaLocalizacaoClientes";

const Dashboard: React.FC = () => {
  const { dadosPedidos, loading, error } = useDashboardData(); // Chamada única do hook

  return (
    <Container fluid>


      <Row className="mb-3">
        <Col md={12} lg={6} xs={12} className="mb-2">
          <PedidosPorClienteChart dadosPedidos={dadosPedidos} loading={loading} error={error} />
        </Col>
        <Col md={12} lg={6} className="mb-2">
          <ValorPedidosPorClienteChart dadosPedidos={dadosPedidos} loading={loading} error={error} />
        </Col>
      </Row>


      <Row className="mb-3">
        <Col xs={12} md={6} lg={6} className="mb-2" >
          <StatusGaugeChart dadosClientes={dadosPedidos} loading={loading} error={error} />
        </Col>
        <Col xs={12} md={6} lg={6} className="mb-2">
          <ClientesGaugeChart dadosClientes={dadosPedidos} loading={loading} error={error} />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col lg={12}>
          <DistribuicaoPedidosChart dadosPedidos={dadosPedidos} loading={loading} error={error} />
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <MapaLocalizacaoClientes dadosClientes={dadosPedidos} loading={loading} error={error} />
        </Col>
      </Row>

    </Container>
  );
};

export default Dashboard;
